var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-category",
    "data-name": "Icon material-outline-category",
    d: "M12,2,6.5,11h11Zm0,3.84L13.93,9H10.06ZM17.5,13A4.5,4.5,0,1,0,22,17.5,4.494,4.494,0,0,0,17.5,13Zm0,7A2.5,2.5,0,1,1,20,17.5,2.5,2.5,0,0,1,17.5,20ZM3,21.5h8v-8H3Zm2-6H9v4H5Z",
    transform: "translate(-3 -2)",
    fill: "#9a9a9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.14b7761b14067eebf2da289efbf35449.svg";
export { ForwardRef as ReactComponent };